export default "__VITE_ASSET__qoWoESij__"